import getConfig from 'next/config';

const DEFAULT_TIMEOUT_IN_MS = 5000;
const GRECAPTCHA_POLL_INTERVAL_IN_MS = 100;
const GRECAPTCHA_MAX_ATTEMPTS = 20;

function waitForGrecaptcha(maxAttempts: number): Promise<void> {
  return new Promise((resolve, reject) => {
    let attempts = 0;
    const check = () => {
      if ('grecaptcha' in window && window.grecaptcha !== undefined) {
        resolve();
        return;
      }
      attempts += 1;
      if (attempts >= maxAttempts) {
        reject(new Error('Recaptcha not loaded'));
        return;
      }
      setTimeout(check, GRECAPTCHA_POLL_INTERVAL_IN_MS);
    };
    check();
  });
}

function getRecaptchaToken(
  action: string,
  timeoutInMs: number = DEFAULT_TIMEOUT_IN_MS,
): Promise<string> {
  const {
    publicRuntimeConfig: { GOOGLE_RECAPTCHA, INTEGRATION_TESTING },
  } = getConfig();

  if (INTEGRATION_TESTING) {
    return Promise.resolve('');
  } else {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        reject(new Error('Recaptcha token request timed out'));
      }, timeoutInMs);

      waitForGrecaptcha(GRECAPTCHA_MAX_ATTEMPTS)
        .then(() => {
          (window as any).grecaptcha?.enterprise.ready(() => {
            return (window as any).grecaptcha.enterprise
              .execute(GOOGLE_RECAPTCHA, {
                action,
              })
              .then((token: string) => {
                clearTimeout(timeout);
                resolve(token);
              })
              .catch((error: unknown) => {
                clearTimeout(timeout);
                reject(error);
              });
          });
        })
        .catch((error: unknown) => {
          clearTimeout(timeout);
          reject(error);
        });
    });
  }
}

export { getRecaptchaToken };
